var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _buyButtonsIntersectionObserver, _mainBottomObserver, _resetTimeout, _isStuck, _animationTimeout, _abortController, _targetAddToCartButton, _currentQuantity, _hiddenByBottom, _StickyAddToCartComponent_instances, setupIntersectionObserver_fn, _handleVariantUpdate, _handleVariantSelected, _handleVariantUnavailable, _handleCartAddComplete, _handleQuantityUpdate, showStickyBar_fn, hideStickyBar_fn, getProductForm_fn, getInitialQuantity_fn, updateButtonText_fn;
import { Component } from "@theme/component";
import { ThemeEvents, QuantitySelectorUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";
import { onAnimationEnd } from "@theme/utilities";
class StickyAddToCartComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _StickyAddToCartComponent_instances);
    __publicField(this, "requiredRefs", ["stickyBar", "addToCartButton", "quantityDisplay", "quantityNumber"]);
    /** @type {IntersectionObserver | null} */
    __privateAdd(this, _buyButtonsIntersectionObserver, null);
    /** @type {IntersectionObserver | null} */
    __privateAdd(this, _mainBottomObserver, null);
    /** @type {number | undefined} */
    __privateAdd(this, _resetTimeout);
    /** @type {boolean} */
    __privateAdd(this, _isStuck, false);
    /** @type {number | null} */
    __privateAdd(this, _animationTimeout, null);
    /** @type {AbortController} */
    __privateAdd(this, _abortController, new AbortController());
    /** @type {HTMLButtonElement | null} */
    __privateAdd(this, _targetAddToCartButton, null);
    /** @type {number} */
    __privateAdd(this, _currentQuantity, 1);
    /** @type {boolean} */
    __privateAdd(this, _hiddenByBottom, false);
    // Public action handlers
    /**
     * Handles the add to cart button click in the sticky bar
     */
    __publicField(this, "handleAddToCartClick", async () => {
      if (!__privateGet(this, _targetAddToCartButton)) return;
      __privateGet(this, _targetAddToCartButton).dataset.puppet = "true";
      __privateGet(this, _targetAddToCartButton).click();
      const cartIcon = document.querySelector(".header-actions__cart-icon");
      if (this.refs.addToCartButton.dataset.added !== "true") {
        this.refs.addToCartButton.dataset.added = "true";
      }
      if (!cartIcon || !this.refs.addToCartButton || !this.refs.productImage) return;
      if (__privateGet(this, _resetTimeout)) clearTimeout(__privateGet(this, _resetTimeout));
      const flyToCartElement = (
        /** @type {FlyToCart} */
        document.createElement("fly-to-cart")
      );
      const sourceStyles = getComputedStyle(this.refs.productImage);
      flyToCartElement.classList.add("fly-to-cart--sticky");
      flyToCartElement.style.setProperty("background-image", `url(${this.refs.productImage.src})`);
      flyToCartElement.useSourceSize = "true";
      flyToCartElement.source = this.refs.productImage;
      flyToCartElement.destination = cartIcon;
      document.body.appendChild(flyToCartElement);
      await onAnimationEnd([this.refs.addToCartButton, flyToCartElement]);
      __privateSet(this, _resetTimeout, setTimeout(() => {
        this.refs.addToCartButton.removeAttribute("data-added");
      }, 800));
    });
    /**
     * Handles variant update events
     * @param {CustomEvent} event - The variant update event
     */
    __privateAdd(this, _handleVariantUpdate, (event) => {
      if (event.detail.data.productId !== this.dataset.productId) return;
      const variant = event.detail.resource;
      const newStickyAddToCart = event.detail.data.html.querySelector("sticky-add-to-cart");
      if (!newStickyAddToCart) return;
      const newStickyBar = newStickyAddToCart.querySelector('[ref="stickyBar"]');
      if (!newStickyBar) return;
      const currentStuck = this.refs.stickyBar.getAttribute("data-stuck") || "false";
      const variantAvailable = newStickyAddToCart.dataset.variantAvailable;
      morph(this.refs.stickyBar, newStickyBar, { childrenOnly: true });
      this.refs.stickyBar.setAttribute("data-stuck", currentStuck);
      this.dataset.variantAvailable = variantAvailable;
      if (variant && variant.id) {
        this.dataset.currentVariantId = variant.id;
      }
      const productForm = __privateMethod(this, _StickyAddToCartComponent_instances, getProductForm_fn).call(this);
      if (productForm) {
        __privateSet(this, _targetAddToCartButton, productForm.querySelector('[ref="addToCartButton"]'));
      }
      if (variant == null) {
        __privateGet(this, _handleVariantUnavailable).call(this);
      }
      __privateMethod(this, _StickyAddToCartComponent_instances, updateButtonText_fn).call(this);
    });
    /**
     * Handles variant selected events
     * @param {CustomEvent} event - The variant selected event
     */
    __privateAdd(this, _handleVariantSelected, (event) => {
      const variantId = event.detail.resource?.id;
      if (!variantId) return;
      this.dataset.currentVariantId = variantId;
    });
    /**
     * Updates the variant title based on selected options when the variant is unavailable
     */
    __privateAdd(this, _handleVariantUnavailable, () => {
      this.dataset.currentVariantId = "";
      const variantTitleElement = this.querySelector(".sticky-add-to-cart__variant");
      const productId = this.dataset.productId;
      const variantPicker = document.querySelector(`variant-picker[data-product-id="${productId}"]`);
      if (!variantTitleElement || !variantPicker) return;
      const selectedOptions = Array.from(variantPicker.querySelectorAll("input:checked")).map((option) => (
        /** @type {HTMLInputElement} */
        option.value
      )).filter((value) => value !== "").join(" / ");
      if (!selectedOptions) return;
      variantTitleElement.textContent = selectedOptions;
    });
    /**
     * Handles cart add complete (success or error) - resets puppet flag
     * @param {CustomEvent} _event - The cart event (unused)
     */
    __privateAdd(this, _handleCartAddComplete, (_event) => {
      if (__privateGet(this, _targetAddToCartButton)) {
        __privateGet(this, _targetAddToCartButton).dataset.puppet = "false";
      }
    });
    /**
     * Handles quantity selector update events
     * @param {QuantitySelectorUpdateEvent} event - The quantity update event
     */
    __privateAdd(this, _handleQuantityUpdate, (event) => {
      if (event.detail.cartLine) return;
      __privateSet(this, _currentQuantity, event.detail.quantity);
      __privateMethod(this, _StickyAddToCartComponent_instances, updateButtonText_fn).call(this);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    __privateMethod(this, _StickyAddToCartComponent_instances, setupIntersectionObserver_fn).call(this);
    const { signal } = __privateGet(this, _abortController);
    const target = this.closest(".shopify-section");
    target?.addEventListener(ThemeEvents.variantUpdate, __privateGet(this, _handleVariantUpdate), { signal });
    target?.addEventListener(ThemeEvents.variantSelected, __privateGet(this, _handleVariantSelected), { signal });
    document.addEventListener(ThemeEvents.cartUpdate, __privateGet(this, _handleCartAddComplete), { signal });
    document.addEventListener(ThemeEvents.cartError, __privateGet(this, _handleCartAddComplete), { signal });
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, __privateGet(this, _handleQuantityUpdate), { signal });
    __privateMethod(this, _StickyAddToCartComponent_instances, getInitialQuantity_fn).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _buyButtonsIntersectionObserver)?.disconnect();
    __privateGet(this, _mainBottomObserver)?.disconnect();
    __privateGet(this, _abortController).abort();
    if (__privateGet(this, _animationTimeout)) {
      clearTimeout(__privateGet(this, _animationTimeout));
    }
  }
}
_buyButtonsIntersectionObserver = new WeakMap();
_mainBottomObserver = new WeakMap();
_resetTimeout = new WeakMap();
_isStuck = new WeakMap();
_animationTimeout = new WeakMap();
_abortController = new WeakMap();
_targetAddToCartButton = new WeakMap();
_currentQuantity = new WeakMap();
_hiddenByBottom = new WeakMap();
_StickyAddToCartComponent_instances = new WeakSet();
/**
 * Sets up the IntersectionObserver to watch the buy buttons visibility
 */
setupIntersectionObserver_fn = function() {
  const productForm = __privateMethod(this, _StickyAddToCartComponent_instances, getProductForm_fn).call(this);
  if (!productForm) return;
  const buyButtonsBlock = productForm.closest(".buy-buttons-block");
  if (!buyButtonsBlock) return;
  const footer = document.querySelector("footer") ?? document.querySelector('[class*="footer-group"]');
  if (!footer) return;
  __privateSet(this, _buyButtonsIntersectionObserver, new IntersectionObserver((entries) => {
    const [entry] = entries;
    if (!entry) return;
    if (!entry.isIntersecting && !__privateGet(this, _isStuck)) {
      const rect = entry.target.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top < 0) {
        __privateMethod(this, _StickyAddToCartComponent_instances, showStickyBar_fn).call(this);
      }
    } else if (entry.isIntersecting && __privateGet(this, _isStuck)) {
      __privateSet(this, _hiddenByBottom, false);
      __privateMethod(this, _StickyAddToCartComponent_instances, hideStickyBar_fn).call(this);
    }
  }));
  __privateSet(this, _mainBottomObserver, new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      if (!entry) return;
      if (entry.isIntersecting && __privateGet(this, _isStuck)) {
        __privateSet(this, _hiddenByBottom, true);
        __privateMethod(this, _StickyAddToCartComponent_instances, hideStickyBar_fn).call(this);
      } else if (!entry.isIntersecting && __privateGet(this, _hiddenByBottom)) {
        const rect = buyButtonsBlock.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top < 0) {
          __privateSet(this, _hiddenByBottom, false);
          __privateMethod(this, _StickyAddToCartComponent_instances, showStickyBar_fn).call(this);
        }
      }
    },
    {
      rootMargin: "200px 0px 0px 0px"
    }
  ));
  __privateGet(this, _buyButtonsIntersectionObserver).observe(buyButtonsBlock);
  __privateGet(this, _mainBottomObserver).observe(footer);
  __privateSet(this, _targetAddToCartButton, productForm.querySelector('[ref="addToCartButton"]'));
};
_handleVariantUpdate = new WeakMap();
_handleVariantSelected = new WeakMap();
_handleVariantUnavailable = new WeakMap();
_handleCartAddComplete = new WeakMap();
_handleQuantityUpdate = new WeakMap();
/**
 * Shows the sticky bar with animation
 */
showStickyBar_fn = function() {
  const { stickyBar } = this.refs;
  __privateSet(this, _isStuck, true);
  stickyBar.dataset.stuck = "true";
};
/**
 * Hides the sticky bar with animation
 */
hideStickyBar_fn = function() {
  const { stickyBar } = this.refs;
  __privateSet(this, _isStuck, false);
  stickyBar.dataset.stuck = "false";
};
// Helper methods
/**
 * Gets the product form element
 * @returns {HTMLElement | null}
 */
getProductForm_fn = function() {
  const productId = this.dataset.productId;
  if (!productId) return null;
  const sectionElement = this.closest(".shopify-section");
  if (!sectionElement) return null;
  const sectionId = sectionElement.id.replace("shopify-section-", "");
  return document.querySelector(
    `#shopify-section-${sectionId} product-form-component[data-product-id="${productId}"]`
  );
};
/**
 * Gets the initial quantity from the data attribute
 */
getInitialQuantity_fn = function() {
  __privateSet(this, _currentQuantity, parseInt(this.dataset.initialQuantity || "1") || 1);
  __privateMethod(this, _StickyAddToCartComponent_instances, updateButtonText_fn).call(this);
};
/**
 * Updates the button text to include quantity
 */
updateButtonText_fn = function() {
  const { addToCartButton, quantityDisplay, quantityNumber } = this.refs;
  const available = !addToCartButton.disabled;
  quantityNumber.textContent = __privateGet(this, _currentQuantity).toString();
  if (available && __privateGet(this, _currentQuantity) > 1) {
    quantityDisplay.style.display = "inline";
  } else {
    quantityDisplay.style.display = "none";
  }
};
if (!customElements.get("sticky-add-to-cart")) {
  customElements.define("sticky-add-to-cart", StickyAddToCartComponent);
}
